import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Portfolio from "@/pages/Apartments";
import CaseStudy from "@/pages/ApartmentDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Services from "@/pages/Consultancy";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/portfolio/:id" element={<CaseStudy />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            {/* Legacy redirects */}
            <Route path="/apartments" element={<Navigate to="/portfolio" replace />} />
            <Route path="/apartments/:id" element={<CaseStudy />} />
            <Route path="/consultancy" element={<Navigate to="/services" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        richColors
        toastOptions={{
          style: {
            fontFamily: "'Poppins', sans-serif",
            borderRadius: "1rem",
          },
        }}
      />
    </div>
  );
}

export default App;
